import * as actions from "./actionTypes";

export const locationSelected = (locationId) => {
  // if (locationId == null) return null;

  return {
    type: actions.LOCATION_SELECTED,
    payload: locationId,
  };
};

// export const updateLocationData = (locationData) => {
//   //   if (chargerData?.length > 0) return null;
//   console.log("locationData Data action: ", locationData);

//   return {
//     type: actions.UPDATE_LOCATION_DATA,
//     payload: locationData,
//   };
// };

export const addLocationIds = (locationId) => {
  return { type: actions.ADD_LOCATION_IDS, payload: locationId };
};

export const resetLocationData = ()=>{
  return {
    type: actions.RESET_LOCATION
  }
}
